import config from "@/config"
import { useEffect } from "react"
import { BFScreen } from "@/components/standard/screen/BFScreen"
import Persona from "persona"

const templates = {
  GovIdAndSelfie: "tmpl_p2ECExZcd4XQPhTvC1Hg37j9",
  UnbrandedGovIdAndSelfie: "itmpl_vbxZLuHyx3iseFKtiFJRgzXQJrkE",
}

export const PersonaEmbed = () => {
  useEffect(() => {
    const client: any = new Persona.Client({
      templateId: templates.GovIdAndSelfie,
      environmentId: config.PERSONA_ENVIRONMENT_ID,
      onReady: () => client.open(),
      onComplete: ({ inquiryId, status, fields }) => {
        console.log(`Sending finished inquiry ${inquiryId} to backend`)
        console.log({ inquiryId, status, fields })
      },
      onCancel: ({ inquiryId, sessionToken }) => {
        console.log("onCancel", { inquiryId, sessionToken })
      },
      onError: (error) => {
        console.log(error)
      },
    })
  }, [])

  return <div id="persona-embed" />
}

export default function BrandedPersonaScreen() {
  return (
    <BFScreen headerSticky={false} dark={false} className={"p-5"}>
      <PersonaEmbed />
    </BFScreen>
  )
}
